import styled from 'styled-components';

export const SelectCellWrapper = styled.div`
`;
